import type { HandView, SeatView } from '@tctp/protocol';

const BETTING = ['fold', 'check', 'call', 'raise'];

/**
 * Speech-bubble text per seat (PokerNow's action bubbles): for the latest street with any betting action, each seat's last
 * betting action on it — `check`, `call N`, `bet N` (a raise when nothing was bet on the street yet), `raise to N`, or `all in`
 * when that action left the seat all in. Blinds, discards, folds and shows make no bubble; nothing once the hand is complete.
 */
export function bubbles(hand: HandView, seats: Array<SeatView | null>): Map<number, string> {
  const out = new Map<number, string>();
  if (hand.phase === 'complete') return out;
  const bets = hand.actions.filter(a => BETTING.includes(a.type));
  if (bets.length === 0) return out;
  const street = bets[bets.length - 1]!.street;
  let bet = 0;
  for (const a of hand.actions) {
    if (a.street !== street) continue;
    if (a.type === 'blind') { bet = Math.max(bet, a.amount!); continue; }
    if (!BETTING.includes(a.type)) continue;
    if (a.type === 'fold') { out.delete(a.seat); continue; }
    if (a.type === 'check') { out.set(a.seat, 'check'); continue; }
    if (seats[a.seat]?.allIn) { out.set(a.seat, 'all in'); if (a.type === 'raise') bet = a.to!; continue; }
    if (a.type === 'call') { out.set(a.seat, `call ${a.amount}`); continue; }
    out.set(a.seat, bet === 0 ? `bet ${a.to}` : `raise to ${a.to}`);
    bet = a.to!;
  }
  return out;
}
